import React, { useState } from "react";

import FileGridUploader from "../FileGridUpload";
import PostButton from "../PostButton";
import ToastMessage from "../ToastMessage";

import { createComment, createReply } from "../../api";

const PhotoComposer = ({ mode, postId, postType, type, comment, close, closeReply }) => {
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isReply = mode === "reply";

  const handleSubmit = async (e) => {
    e?.preventDefault?.();

    if (isReply && !comment?.id) {
      ToastMessage("Comment ID is missing.");
      return;
    }

    if (!files.length) {
      ToastMessage(isReply ? "Please choose a photo." : "Please add at least one image before commenting.");
      return;
    }

    const selectedFile = files[0]?.file;
    if (!selectedFile) return;

    const formData = new FormData();

    formData.append("type", isReply ? type : postType);

    if (isReply) formData.append("comment_id", comment.id);
    else formData.append("post_id", postId);

    formData.append("content", selectedFile);

    try {
      setIsSubmitting(true);

      const res = isReply ? await createReply(formData) : await createComment(formData);

      if (res?.data?.message) {
        ToastMessage(res.data.message);
        setFiles([]);

        if (isReply) closeReply?.();
        else close?.();
      }
    } catch (error) {
      console.error(isReply ? "Photo reply error:" : "Photo comment error:", error);
      console.error(error?.response?.data);

      ToastMessage(error?.response?.data?.message || (isReply ? "Failed to send photo reply." : "Error creating photo comment."));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="overflow-x-hidden">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="relative overflow-visible rounded-xl border border-gray-200 bg-gray-50/40 p-3">
          <FileGridUploader allowMultiple={false} maxFiles={1} files={files} setFiles={setFiles} acceptedFileTypes="image/*" />
        </div>

        {files.length > 0 && (
          <div className="mt-3">
            <PostButton type="submit" text={isSubmitting ? "Sending..." : isReply ? "Reply" : undefined} disabled={isSubmitting} />
          </div>
        )}
      </form>
    </div>
  );
};

export default PhotoComposer;